import React, { useMemo } from 'react'
import { ALBUMS, SHOWCASES } from '@disco/constants/FeatureTypes'
import { BRIEFS, INBOX_TYPES } from '@disco/constants/GroupTypes'
import {
  ALBUM_VIEW,
  ARTIST_VIEW,
  BRIEF_CLOSED_VIEW,
  BRIEF_OPEN_VIEW,
  BRIEF_MINE_VIEW,
  BRIEF_ALL_VIEW,
} from '@disco/constants/ViewTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { Tabs } from 'components/ds'
import type { Option } from '../select-options'
import { libViewOptions } from '../select-options'
import styles from './index.module.css'

type Props = {
  groupType?: string
  value: string
  onChange: (value: string) => void
}

const ViewSelector = ({
  groupType,
  value,
  onChange,
}: Props): React.ReactElement => {
  const albumsEnabled: boolean = useFeatureEnabled(ALBUMS)
  const showcasesEnabled: boolean = useFeatureEnabled(SHOWCASES)
  const options = useMemo(() => {
    let filteredOptions = libViewOptions
    const isInbox: boolean = INBOX_TYPES.includes(groupType)
    const isBriefsList: boolean = BRIEFS.includes(groupType)

    if (isBriefsList) {
      filteredOptions = [
        { label: 'All', value: BRIEF_ALL_VIEW },
        { label: 'Open', value: BRIEF_OPEN_VIEW },
        { label: 'Closed', value: BRIEF_CLOSED_VIEW },
        { label: 'Mine', value: BRIEF_MINE_VIEW },
      ]
    }

    if (!albumsEnabled || isInbox) {
      filteredOptions = filteredOptions.filter(
        (option: Option) => option.value !== ALBUM_VIEW,
      )
    }

    if (!showcasesEnabled || isInbox) {
      filteredOptions = filteredOptions.filter(
        (option: Option) => option.value !== ARTIST_VIEW,
      )
    }

    return filteredOptions
  }, [albumsEnabled, groupType, showcasesEnabled])

  return (
    <Tabs.Root value={value} onValueChange={onChange}>
      <Tabs.List size="1" className={styles.tabsList}>
        {options.map((option: Option) => (
          <Tabs.Trigger key={option.value} value={option.value}>
            {option.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  )
}

export default ViewSelector
